exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-bc8d723c] .el-table__header{width:840px!important}", ""]);

// exports
